<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle
                    :pageTitle="$t('pages.titles.serviceThree')"
                    :pageParentTitle="$t('pages.parents.services')"
                />
            </template>
        </PageHeader>
        <ServicesDetails />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import ServicesDetails from '../Service/Three/ServicesDetails'
import Footer from '../Layout/Footer'
import FreeTrial from '../Common/FreeTrial'
export default {
    name: 'ServicePageThree',
    components: {
        Navbar,
                PageHeader,
        PageTitle,
        ServicesDetails,
        FreeTrial,
        Footer,
    }
}
</script>
